import Head from "next/head";
import { generateNextSeo } from "next-seo/pages";
import { buildCanonicalUrl } from "lib/seo";

import Navigation from "components/navigation/navigation";
import Footer from "components/footer/footer";
import ErrorBoundary from "components/errorBoundary/errorBoundary";

import type { SiftedForStartupsPageData } from "content-ui/sifted-for-startups/fetcher";

import { fetchNavbarAndFooter } from "lib/fetchers/common";
import { fetchSiftedForStartupsPageData } from "content-ui/sifted-for-startups/fetcher";

import SiftedForStartupsView from "content-ui/sifted-for-startups";
import { SEO_SIFTED_ON_PINK_IMAGE } from "lib/constants/shared";

export async function getServerSideProps({ res, preview = false }) {
  const [menuItems, pageData] = await Promise.all([
    fetchNavbarAndFooter(),
    fetchSiftedForStartupsPageData({ preview }),
  ]);

  res.setHeader(
    "Cache-Control",
    "public, s-maxage=10, stale-while-revalidate=59"
  );

  return {
    props: {
      pageData,
      previewMode: preview,
      __initialState: {
        sitewideOption: { ...menuItems },
      },
    },
  };
}

type PageProps = {
  pageData: SiftedForStartupsPageData;
};

const SiftedForStartupsPage = (props: PageProps) => {
  const { seo } = props.pageData;
  const title = seo?.title || "Sifted for Startups";
  const description = seo?.description || "";
  const seoImage = seo?.image?.url || SEO_SIFTED_ON_PINK_IMAGE;

  return (
    <>
      <Head>
        {generateNextSeo({
          title: title,
          description: description,
          canonical: buildCanonicalUrl("/sifted-for-startups"),
          openGraph: {
            title: title,
            description: description,
            images: [{ url: seoImage }],
          },
          twitter: {
            handle: "@siftedeu",
            site: "@siftedeu",
            cardType: "summary_large_image",
          },
        })}
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Navigation />
      <ErrorBoundary>
        <SiftedForStartupsView data={props.pageData} />
      </ErrorBoundary>
      <Footer />
    </>
  );
};

export default SiftedForStartupsPage;
